'use strict';

angular.module('AcaApp').constant('LOGIN_TEXT', {
  INVALIDUSERPASSWORD: 'Sorry, we do not recognize your login combination. Please try again.',
  SUCCESS: 'success',
  PASSWORD_EXPIRED: 'password_expired',
  ACCOUNT_LOCKED: 'account_locked'
});

angular.module('AcaApp').constant('AUTH_EVENTS', {
  LOGINSUCCESS: 'auth-login-success'
});

angular.module('AcaApp').constant('PASSWORD_MESSAGES', {
  PASSDONTMATCH: 'Sorry, your passwords do not match. Please try again.',
  PASSREQUIREMENTS: 'Sorry, your password does not meet the requirements listed below. Please try again.',
  PASSREPETING: 'Sorry, your password cannot contain three or more repeating characters. Please try again.',
  PASS_USERNAME: 'Sorry, your password cannot contain your username. Please try again.',
  PASS_EMAIL: 'Sorry, your password cannot contain your email address. Please try again.',
  PASSWORD_CHANGED_FAILED: 'Change password attempt failed.',
  SPECIAL_CHARS: '1 or more special characters (~ ! @ # ( ) _ = { } | : ; , . ^ + $ ` * [ ] - ?)'
});

angular.module('AcaApp').constant('EMAIL_MESSAGES', {
  EMAILFORMAT: 'A valid email is required (name@email.com)'
});

angular.module('AcaApp').constant('FORM_MESSAGES', {
  REQUIRED: 'Employee & Employer fields are mandatory',
  INCOMPLETE: 'This form is incomplete',
  REQUIREDDEPENDENT: 'Employee field is mandatory',
  REQUIREDPARTICIPANT: 'Participant field is mandatory',
  MAPNAMEALREADYEXISTS: 'This map already exists. Please choose a different map name.',
  SELECTONEFORM: 'Should select one form.',
  SELECTONEDATA: 'Should select one data.',
  SELECTONEDATATYPE: 'Should select one data type.',
  SELECTONEMAP: 'Should select one map to clone.',
  ERRORSAVING1095BSUBS: 'Error saving the 1095-B Subscriber',
  ERRORUPDATING1095BSUBS: 'Error updating the 1095-B Subscriber',
  ERRORSAVING1095CSUBS: 'Error saving the 1095-C Subscriber',
  ERRORUPDATING1095CSUBS: 'Error updating the 1095-C Subscriber',
  ERRORSAVING1095BDEP: 'Error saving the 1095-B Dependent',
  ERRORSAVING1095CDEP: 'Error saving the 1095-C Dependent',
  ERRORUPDATING1095BDEP: 'Error updating the 1095-B Dependent',
  ERRORUPDATING1095CDEP: 'Error updating the 1095-C Dependent',
  INVALIDDATE: 'Invalid Date',
  INVALIDPIN: 'The PIN should be 10 characters',
  INVALIDPINNUMBER: 'The PIN should be numbers',
  INVALIDEIN: '(PART IV - ALE Group) The EIN should be 9 characters and only Numbers',
  MOSTDATECURRENTB: '(0024) If present, 1094-B Signature Date (X4B_SIGNATUREDATE) must be <= today.',
  MOSTDATECURRENTC: '(0026) 1094-C Signature Date (X4C_SIGNATUREDATE) must be <= today.',
  TOTALFORMSFILED: '(0034) If Box 19 (X4C_AUTHORITATIVEXMITIND) is checked, then Box 20 (X4C_TOTALFORMSFILED) must be greater than 0.',
  GOVTENTITYEMPLOYER: '(0036) If Designated Government Entity (X4C_GOVTENTITYEMPLOYER) is populated, then it must be a valid Payer ID (PTIN), other than the employer.',
  DATAGOVTENTITYEMPLOYER: '(0038) If Designated Government Entity (X4C_GOVTENTITYEMPLOYER) has a value, then its corresponding Contact (CONTACT) and Contact Phone (CONTACTPHONE) fields must have valid values, while TIN Type (PTINTYPE) must be = EIN.',
  MECOINDICATOR: '(X4C001) If Box 22B (X4C_QLFYOFFERMETHODTRIND) or Box 22D (X4C_PCTOFFERMETHODIND) are checked, then at least 1 month must be checked in Part III column A. Line 22B and Line 22D',
  FECOUNT: '(X4C002) If Box 19 (X4C_AUTHORITATIVEXMITIND) is checked and 22D (X4C_PCTOFFERMETHODIND) is not checked, then at least 1 month must be > 0 in Part III column B. Line19',
  TECOUNT: '(X4C003) If Box 19 (X4C_AUTHORITATIVEXMITIND) is checked, then at least 1 month must be > 0 in Part III column C Line19',
  AGINDICATOR: '(X4C004) If Box 21 (X4C_AGGRGROUPMEMBERIND) is checked, then at least 1 month must be checked in Part III column D. Line21',
  NOAGINDICATOR: '(X4C005) If Box 21 (X4C_AGGRGROUPMENBERIND) is not checked, then all month must not be checked in Part III column D. Line21',
  S4TRINDICATOR: '(X4C006) If Box 22C (X4C_SECT4980HRELIEFIND) is checked, then at least one month must have a value in Part III column E and all column E values must be the same for each month entered.',
  NOS4TRINDICATOR: '(X4C007) If Box 22C is not checked, then all months in Part III, Column E must be empty  Line22c',
  FILTERVALUE: 'The field Value is required',
  FILTERFIELD: 'The field Filter is required',
  LABELFILTERADD: 'Add Filter',
  LABELFILTEREDIT: 'Edit Filter',
  FILTERFIXEDVALUE: 'Fixed Value',
  INVALIDCONTACT: 'Contact Name must have at least one valid character and two words',
  INVALIDCONTACTPHONE: 'Contact Phone must be numbers only and greater than 9 digits'
});

angular.module('AcaApp').constant('USERTYPE', {
  REQUIRED: 'A user type is required'
});

angular.module('AcaApp').constant('EXCEPTION', {
  INVALIDTOKEN: 'INVALID_TOKEN',
  MAXFAILEDLOGINS: 'MAX_FAILED_LOGINS',
  ACCOUNTDISABLED: 'ACCOUNT_DISABLED',
  BADLOGIN: 'BAD_LOGIN',
  RECORDNOTFOUND: 'RECORDNOTFOUND',
  CLIENTDISABLED: 'CLIENT_DISABLED',
  FORMSTRANSMITTED: 'ERRORFORMMARKEDASTRANSMITTED',
  EMPRELATEDFORMRECORDS: 'EMPLOYERRELATEDFORMRECORDSFOUND',
  PARTRELATEDFORMRECORDS: 'RELATEDFORMRECORDSFOUND',
  DUPLICATEDFORM: 'DUPLICATED_FORM'
});

angular.module('AcaApp').constant('FORMATS', {
  DATEFORMAT: 'm/d/Y'
});

angular.module('AcaApp').constant('SEND_MESSAGES', {
  NOFORMSELECTED: 'No form has been selected. Please select form to continue',
  NOPAYERSELECTED: 'No employer has been selected. Please select employer(s) to continue',
  SENDPRINT: 'send-print',
  ERRORMESSAGECLASS: 'send-confirmation-error',
  ERRORMESSAGEEMAILCLASS: 'send-email-error',
  NOEMAILSELECTED: 'At least one email must be selected *',
  MESSAGEOK: 'Your request has been sent.',
  OKMESSAGECLASS: 'send-email-ok',
  PRINTHISTORYDATA: 'print-history-data',
  PRINT_STATUS_DETAIL: 'print-status-detail',
  PRINT_DETAIL_FAIL: 'send-detail-failed',
  PRINT_ALREADY_APPROVED: 'print-already-approved',
  FILE_AVAILABLE: 'Archive PDF',
  FILE_NOT_AVAILABLE: 'File not available',
  PRINT_FILE_FAILED: 'send-file-failed',
  XMIT_FILE_FAILED: 'generated-file-failed',
  SENDXMIT: 'send-transmittal',
  BACKCHECKLIST: 'send-check-list',
  NOSTATESELECTED: 'No state has been selected. Please select state to continue'
});

angular.module('AcaApp').constant('OUTPUT_TYPE', {
  PDF: 'PDF',
  PRINTSERVICE: 'PRINTSERVICE',
  TRANSMITTAL: 'ACA',
  TRANSMITTALSPLIT: 'SPLIT',
  STATE_TRANSMITTAL: 'STATE'
});

angular.module('AcaApp').constant('SETTINGS', {
  NOTAVAILABLE: 'Not Available',
  RESET: 'Reset',
  DATASUCCESSFULLY: 'Data Successfully Reset',
  RENEWTOKEN_EACH_MILLISECONDS: 20000,
  TRANSMITTAL: 'transmittal',
  PRINTSERVICE: 'print',
  STANDARDMAPS: 'ACA.STANDARDMAPS',
  CORRECTIONMAPS: 'CORRECTIONMAP.',
  MESSAGEDELETEOK: 'Map was successfully deleted',
  MESSAGEDELETEKO: 'Map could not be deleted'
});

angular.module('AcaApp').constant('PRINTNOTES', {
  REQUIRED: 'Note Name is mandatory.'
});

angular.module('AcaApp').constant('XMIT_STATUS', {
  QUEUED_FOR_SUBMISSION: -1,
  QUEUED: 0,
  IRS_PROCESSING: 1,
  COMPLETE: 2
});

angular.module('AcaApp').constant('SURVEY', {
  SCALEMANDATORY: 'Please enter a rating to continue'
});

angular.module('AcaApp').constant('XMIT_PAGE', {
  SEND_TRANSMITTAL_STATUS_DETAIL: 'send-transmittal-status-detail',
  SEND_TRANSMITTAL_STATUS: 'send-transmittal-status',
  SEND_STATE_TRANSMITTAL_STATUS: 'send-state-transmittal-status',
  XMIT_STATUS: 'xmit-status',
  SEND_TRANSMITTAL_STATES: 'send-transmittal-states',
  SEND_TRANSMITTAL_STATES_RESUME: 'send-transmittal-states-resume'
});

angular.module('AcaApp').constant('CORRECTIONS_PAGE', {
  CORRECTIONS: 'corrections',
  CORRECTIONS_REPORT: 'correction-report',
  ERROR_PAYEE_FORM: 'error-payee-form',
  ERROR_EMPLOYER_FORM: 'error-employer-form',
  RETRANSMIT_CORRECTED: 'retransmit-corrected',
  NOFORMSSELECTED: 'No form has been selected. Please select form(s) to continue.',
  NOPAYERSSELECTED: 'No employer has been selected. Please select employer(s) to continue.',
  XMIT_SUCCESS: 'correction-xmit-success',
  XMIT_ERROR: 'correction-xmit-error',
  XMIT_STATUS: 'xmit-status',
  BACK_OPTIONS_BUTTON: 'Back to Send Options',
  SYSTEM_ERROR: 'System Error'
});

angular.module('AcaApp').constant('CONSTANTS', {
  INTEGER_NULL: -2147483648,
  TAXYEAR2015: '2015'
});

angular.module('AcaApp').constant('HIST_STATUS_TEXT', {
  PARENTIMPORT: 'importmodule',
  PARENTPRINT: 'printmodule',
  PARENTTRANSMITTAL: 'transmittalmodule',
  PARENTSTATETRANSMITTAL: 'statetransmittalmodule',
  MODULETITLEIMPORT: 'Import Status',
  MODULETITLETRANSMITTAL: 'Send - Transmittal Status',
  MODULETITLEPRINT: 'Send - Print Status',
  MODULETITLESTATETRANSMITTAL: 'Files Transmitted to States',
  GOBACKTOIMPORT: 'upload-your-file',
  GOBACKTOSEND: 'send',
  APPROVEWAITINGFORPRINTING: 'Approved and Waiting for Printing',
  WAITINGMESSAGE: 'Queued for Print Vendor',
  READYFORSUBMISSION: 'Ready for Submission',
  FAILED: 'Failed',
  INPROCESS: 'In Process',
  SUBMITTEDFORPRINTING: 'Submitted for Printing'
});

angular.module('AcaApp').constant('LRJ_MANAGER', {
  JOBTYPE: {
    IMPORT: 'IMPORT',
    PRINT: 'PRINT',
    XMIT: 'XMIT'
  },
  JOBSTATUS: {
    INPROCESS: 'In Process',
    FAILED: 'Failed'
  },
  FILTERSDATA: {
    FILENAME: /^FileName\: /,
    PRINTPAYERS: /^Print Payers - Lrj\: /,
    XMITPAYERS: /^Xmit Payers - Lrj\: /,
    ID: /^Id\: /,
    ERROR: / Error\: /
  },
  PROCESSIMPORT: 'ProcessImport',
  PROCESSPRINT: 'ProcessPrint',
  PROCESSTRANSMITTAL: 'ProcessTransmittal'
});

angular.module(ModuleName).constant(
  'PARTICIPANT_FORM', {
    TY2015: 'app/views/participant/modals/form-participant.html',
    TY2016: 'app/views/participant/modals/form-participant-ty-2016.html',
    TY2017: 'app/views/participant/modals/form-participant-ty-2016.html',
    TY2018: 'app/views/participant/modals/form-participant-ty-2016.html',
    TY2019: 'app/views/participant/modals/form-participant-ty-2019.html',
    TY2020: 'app/views/participant/modals/form-participant-ty-2019.html',
    TY2021: 'app/views/participant/modals/form-participant-ty-2019.html',
    TY2022: 'app/views/participant/modals/form-participant-ty-2019.html',
    TY2023: 'app/views/participant/modals/form-participant-ty-2019.html',
    TY2024: 'app/views/participant/modals/form-participant-ty-2019.html',
    NO_CITY: 'SOVOS'
  }
);

angular.module(ModuleName).constant(
  'ERROR', {
    ERRORAPAGE: 'error',
    TRANSMITTAL: {
      ERRORTITLE: 'Send Options',
      ERRORSUBMITTRANSMITTAL: 'Sorry, but we encountered an error while submitting your transmittal file.',
      ERRORSENDTRANSMITTAL: 'Sorry, but we encountered an error while sending your transmittal file.',
      ERRORCANCELTRANSMITTAL: 'Sorry, but we encountered an error while cancel your transmittal file.',
      SUPPORTASSIST: 'Please contact customer support for assistance at 1-800-373-8229 and give them the following information:',
      BACK_OPTIONS_BUTTON: 'Back to Send Options',
    }
  }
);

angular.module(ModuleName).constant(
  'IMPORT', {
    STANDARD1094C: 'Standard_1094C',
    ORIGINALIMPORT: 'original',
    UPDATEIMPORT: 'update'
  }
);
